import EventBus from './EventBus';

let searchState = false;
let searchTerm = null;

const searchListeners = [];
const searchStateListeners = [];

let searchDebounce = null;

export const activateSearch = () => {
  searchState = true;
  notifySearchStateListeners();
};

export const deactivateSearch = (notify = true) => {
  if (!searchState && !searchTerm) {
    return;
  }

  searchState = false;
  searchTerm = null;
  if (!notify) {
    return;
  }
  notifySearchStateListeners();
  notifySearchListeners();
  EventBus.notify(EventBus.TYPE.SEARCH_TERM_CHANGED);
};

export const getSearchState = () => searchState;

export const addSearchStateListener = listener => {
  searchStateListeners.push(listener);
};

export const removeSearchStateListener = listener => {
  const pos = searchStateListeners.indexOf(listener);

  if (pos !== -1) {
    searchStateListeners.splice(pos, 1);
  }
};

const notifySearchStateListeners = () => {
  searchStateListeners.forEach(listener => {
    listener(searchState);
  });
};

// ------------------------------------------------

export const cancelSearchDebounce = () => {
  if (searchDebounce) {
    clearTimeout(searchDebounce);
    searchDebounce = null;
  }
};

export const setSearchTerm = term => {
  searchTerm = term;
  notifySearchListeners();

  cancelSearchDebounce();

  searchDebounce = setTimeout(() => {
    EventBus.notify(EventBus.TYPE.SEARCH_TERM_CHANGED);
  }, 500);
};

export const search = () => {
  notifySearchListeners();
};

export const getSearchTerm = () => searchTerm;

export const addSearchListener = listener => {
  searchListeners.push(listener);
};

export const removeSearchListener = listener => {
  const pos = searchListeners.indexOf(listener);

  if (pos !== -1) {
    searchListeners.splice(pos, 1);
  }
};

const notifySearchListeners = () => {
  searchListeners.forEach(listener => {
    listener(searchTerm);
  });
};
